// eslint-disable-next-line
export const GAME_FLOW_TYPES = {
  LOAD_STAGE: 'LOAD_STAGE',
  UP_FORCE_LOAD_STAGE: 'UP_FORCE_LOAD_STAGE',
  SET_VALID_STAGES: 'SET_VALID_STAGES',
  REFRESH_ROLE_DISTRIBUTION: 'REFRESH_ROLE_DISTRIBUTION',
};
